export default {
  name: "Report360List",
  data() {
    return {
      search: "",
      headers: [
        {
          text: "",
          value: "imageUrl",
          width: 120
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]["Report360List.Name"],
          value: "name",
          width: 300
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Wing"],
          value: "wingName",
          width: 350
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Room"],
          value: "roomName"
        }
      ]
    }
  },
  computed: {
    residents() {
      return this.$store.state.residentModule.residentsShortData;
    }
  },
  methods: {
    backToReports() {
      this.$router.push("/reports");
    },
    openReport(row): void {
      this.$router.push("/reports/reports360/" + row.id);
    }
  }
}
